<template>
    <rounded-container v-if="priceRows.length" variant="dark">
        <template v-slot:title>Prices by source</template>

        <div class="py-1">
            <b-row
                v-for="(row, rowIndex) in priceRows"
                :key="row.data_source"
                :class="rowClass(rowIndex)"
                class="px-3 py-2"
            >
                <b-col>
                    <span :class="row.stored ? '' : 'text-secondary'">
                        {{ sourceLabel(row.data_source) }}
                    </span>
                    <b-badge
                        v-for="tag in row.tags"
                        :key="tag"
                        :variant="tagVariant(tag)"
                        class="ml-2"
                    >
                        {{ tag }}
                    </b-badge>
                </b-col>
                <b-col cols="5" class="format-price text-left">
                    ${{ formatPrice(row.price) }}
                    <span v-if="row.distance" class="text-secondary ml-2">{{ row.distance.formatted }}</span>
                </b-col>
            </b-row>
        </div>
    </rounded-container>
</template>

<script>
import formatter from "@/mixins/formatter";
import RoundedContainer from "@/components/style/RoundedContainer.vue";

const SOURCE_LABELS = {
    kraken_stocks: "Kraken stocks",
    kraken_xstocks: "Kraken xStocks",
    kraken: "Kraken",
    binance: "Binance",
    sheets: "Google Sheet",
    etoro: "eToro",
};

// The API decides which tags a price carries. A tag it has not met yet still paints.
const TAG_VARIANTS = {
    "in-use": "info",
    stale: "warning",
};

export default {
    name: "AssetPriceSources",
    mixins: [formatter],
    components: {
        RoundedContainer,
    },
    props: {
        symbol: {
            type: String,
            required: true,
        },
        lowestOpenPrice: {
            type: Number,
            default: null,
        },
    },
    computed: {
        /* Every source the last sync heard from, the one in use first. Each is measured
           against the lowest open position, the reference the rest of the page uses. */
        priceRows() {
            return this.$store.getters.getPricesForSymbol(this.symbol).map((row) => ({
                ...row,
                distance: this.lowestOpenPrice
                    ? this.getDistance(this.lowestOpenPrice, row.price)
                    : null,
            }));
        },
    },
    methods: {
        sourceLabel(source) {
            return SOURCE_LABELS[source] || source;
        },
        tagVariant(tag) {
            return TAG_VARIANTS[tag] || "secondary";
        },
    },
};
</script>
